// Don't remove "<T>", it is used for setting value type inference
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class Setting<T> {
  constructor(public key: string) {}
}
